export default {"src":"/_next/static/media/quality.ea8e0737.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};